import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Clock } from 'lucide-react';
import { Button } from '../ui/button';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('dentalToken')}` } });

export const ReferralFollowupReminder = () => {
  const [items, setItems] = useState([]);
  const load = () => axios.get(`${BACKEND}/api/ai-referrals/pending`, auth()).then((r) => setItems(r.data.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!items.length) return null;
  const received = async (id) => { await axios.post(`${BACKEND}/api/ai-referrals/${id}/mark-received`, {}, auth()); load(); };
  return (
    <div className="mb-4 rounded-xl border border-amber-300 bg-amber-50 p-4" data-testid="referral-followup-reminder">
      <p className="font-semibold text-amber-900 flex items-center gap-2"><Clock className="h-4 w-4" /> {items.length} referral(s) not yet confirmed by the specialist</p>
      <div className="mt-2 space-y-1.5">
        {items.map((r) => (
          <div key={r.id} className="flex flex-wrap items-center gap-2 text-sm text-amber-900">
            <span><b>{r.patientName}</b> → {r.referralSourceName} ({r.specialty}) · {r.followUpSentAt ? 'follow-up email sent' : 'follow-up going out shortly'}</span>
            <Button size="sm" variant="outline" className="ml-auto h-7 bg-white" onClick={() => received(r.id)} data-testid={`referral-mark-received-${r.id}`}>Mark received</Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReferralFollowupReminder;
